<template>
    <div>
        <div v-if="isEdit">
            <el-form label-width="120px">
                <el-form-item label="商机名称：" required>
                    <el-input size="medium" placeholder="请输入商机名称" v-model="editForm.businessName"></el-input>
                </el-form-item>
                <el-form-item label="领域：" required>
                    <el-select 
                        size="medium" 
                        v-model="editForm.domainId" 
                        placeholder="请选择" 
                        style="width: 100%;"
                        @change="getOptionServiceStage(2)"
                    >
                        <el-option 
                            v-for="(item,index) in domianList"
                            :value="item.domainid" 
                            :label="item.domainname" 
                            :key="index" 
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="项目类型：" required>
                    <el-select 
                    size="medium" 
                    v-model="editForm.serviceStageId" 
                    placeholder="请选择" 
                    style="width: 100%;"
                >
                    <el-option 
                        v-for="(item,index) in serviceStageList"
                        :value="item.servicestageid" 
                        :label="item.servicestagename" 
                        :key="index" 
                    ></el-option>
                </el-select>
                </el-form-item>
                <el-form-item label="对应客户：" required>
                    <el-select 
                        size="medium"
                        filterable
                        v-model="form.custId" 
                        placeholder="请选择" 
                        style="width: 100%"
                        disabled
                    >
                        <el-option 
                            v-for="(item,index) in dykhList"
                            :label="item.custName" 
                            :value="item.custId"
                            :key="index"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="预计签单日期：">
                    <el-date-picker
                        size="medium"
                        v-model="editForm.preOrderDate"
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 100%;"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="预计成单金额：">
                    <el-input size="medium" placeholder="请输入预计成单金额（元）" v-model.number="editForm.preOrderAmount"></el-input>
                </el-form-item>
                <el-form-item label="备注：">
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 2}"
                        placeholder="请输入内容"
                        v-model="editForm.remark">
                    </el-input>
                </el-form-item>
            </el-form>
        </div>
        <div v-else>
            <el-form label-width="120px">
                <el-form-item label="商机名称：">
                    <div>{{form.businessName}}</div>
                </el-form-item>
                <el-form-item label="领域：">
                    <div>{{form.domain}}</div>
                </el-form-item>
                <el-form-item label="项目类型：">
                    <div>{{form.serviceStageName}}</div>
                </el-form-item>
                <el-form-item label="对应客户：">
                    <div>{{form.custName}}</div>
                </el-form-item>
                <el-form-item label="预计成单日期：">
                    <div>{{form.preOrderDate || '--'}}</div>
                </el-form-item>
                <el-form-item label="预计成单金额：">
                    <div v-if="form.preOrderAmount">{{form.preOrderAmount}}元</div>
                    <div v-else>--</div>
                </el-form-item>
                <el-form-item label="备注：">
                    <div>{{form.remark || '--'}}</div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import { getStorageAdminUser } from '@/utils/store'
    import {
        prodDomains,                    //获取领域
        optionServiceStage,             //项目类型（服务类型）
        corCustList,                    //对应客户
    } from "@/service/customerInformation";
    export default {
        data() {
            return {
                DialogsType: '',
                textarea2: '',



                isEdit: false,
                form: {
                    businessName: '',
                    domain: '',
                    serviceStageName: '',
                    custName: '',
                    preOrderAmount: '',
                    remark: ''
                },
                editForm: {
                    businessName: '',
                    domainId: '',       //领域id
                    serviceStageId: '', //项目类型id
                    custId: '',         //客户id
                    preOrderDate: '',   //预计成单日期
                    preOrderAmount: '', //预计成单金额
                    remark: '',         //备注
                },
                domianList: [],         //领域
                serviceStageList: [],   //项目类型
                dykhList: [],           //对应客户

            }
        },
        methods: {
            // 获取基本信息
            getDealerBasicInfo(data,is){
                this.form = data;
                delete this.form.progRecord
                this.isEdit = is
            },
            // 编辑基本信息
            editDealerBasicInfo(data,is) {
                this.$nextTick(()=> {
                    if(!data.preOrderAmount) {
                        data.preOrderAmount = ''
                    }
                    this.editForm = data
                    delete this.editForm.progRecord
                    this.getProdDomains();
                    this.getOptionServiceStage();
                    this.getCorCustList();
                })
                console.log(data)
                this.isEdit = is
            },
            // 获取领域
            getProdDomains(){
                prodDomains().then(res=>{
                    this.domianList = res.Data
                })
            },
            // 获取项目类型(通过领域id)
            getOptionServiceStage(c){
                if(c==2) {
                    this.serviceStageList = []
                    this.editForm.serviceStageId = ''
                }
                let data = {
                    domainId: this.editForm.domainId
                }
                optionServiceStage(data).then(res=> {
                    this.serviceStageList = res.Data
                })
            },
            // 对应客户
            getCorCustList(){
                let data = {
                    principalId: this.editForm.principalId,
                    keyword: '',
                }
                corCustList(data).then(res=> {
                    this.dykhList = res.Data
                })
            },
            // 保存
            saveBasicInfo(){
                let data = Object.assign({}, this.editForm);
                if(!data.businessName) {
                    return this.$message.warning('商机名称不能为空')
                }
                if(!data.domainId) {
                    return this.$message.warning('请选择领域')
                }
                if(!data.serviceStageId) {
                    return this.$message.warning('请选择项目类型')
                }
                data.updateMan = getStorageAdminUser().nickname
                data.updateManId = getStorageAdminUser().role_id
                this.$emit('confirmBasicInfo', data)
            },
        }
    }
</script>
